import { createBasicSelector } from 'util/redux'
import { selectBooleanPreferenceByName } from './selectBooleanPreferenceByName'

export const selectCurrentUserPrefersAutoAdvanceOnClosed = createBasicSelector(
  state =>
    selectBooleanPreferenceByName(state, 'chat_auto_advance_on_close', true)
)
